import { useEffect, useRef, useState } from 'react';

const testimonials = [
  {
    name: 'Sadhna Sargam',
    role: 'Bollywood Playback Singer',
    img: 'https://readdy.ai/api/search-image?query=Indian%20female%20Bollywood%20playback%20singer%20elegant%20portrait%2C%20graceful%20saree%2C%20professional%20studio%20photography%2C%20warm%20golden%20lighting&width=200&height=200&seq=test001&orientation=squarish',
    quote: 'Spiritual Bhakti has been instrumental in bringing my Hindi Devotional music to millions of listeners across India. Their professionalism and dedication to quality is unmatched in the industry.',
  },
  {
    name: 'Suresh Wadkar',
    role: 'Legendary Playback Singer',
    img: 'https://readdy.ai/api/search-image?query=Indian%20male%20legendary%20Bollywood%20playback%20singer%20formal%20portrait%2C%20dignified%20expression%2C%20professional%20photography%2C%20warm%20studio%20lighting&width=200&height=200&seq=test002&orientation=squarish',
    quote: 'Working with Spiritual Bhakti is always a pleasure. They understand the soul of Indian music and have the infrastructure to take it to the world. A truly world-class organization.',
  },
  {
    name: 'Poonam Mishra',
    role: 'Maithili Folk Artist',
    img: 'https://readdy.ai/api/search-image?query=Indian%20female%20Maithili%20folk%20singer%20traditional%20attire%20portrait%2C%20warm%20expression%2C%20professional%20photography%2C%20cultural%20heritage&width=200&height=200&seq=test003&orientation=squarish',
    quote: 'Spiritual Bhakti gave my Maithili folk music a global platform. From a small village artist to millions of YouTube subscribers — this journey would not have been possible without them.',
  },
  {
    name: 'Guddu Rangila',
    role: 'Bhojpuri Entertainment Artist',
    img: 'https://readdy.ai/api/search-image?query=Indian%20male%20Bhojpuri%20entertainer%20vibrant%20colorful%20attire%20portrait%2C%20energetic%20expression%2C%20professional%20photography&width=200&height=200&seq=test004&orientation=squarish',
    quote: 'The team at Spiritual Bhakti is like family. They have supported my career at every step — from recording to promotion. I am proud to be part of this legendary label.',
  },
];

export default function TestimonialsSection() {
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, { threshold: 0.1 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const t = setInterval(() => setActive((a) => (a + 1) % testimonials.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <section ref={ref} className="section-padding bg-[#0d0d0d] relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-[#d4af37]/20 to-transparent"></div>
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="text-[#d4af37]/3 font-heading text-[200px] font-bold select-none">&ldquo;</div>
      </div>

      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className={`text-center mb-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="w-8 h-px bg-[#d4af37]"></span>
            <span className="text-[#d4af37] text-xs font-semibold tracking-[3px] uppercase">Testimonials</span>
            <span className="w-8 h-px bg-[#d4af37]"></span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white">
            What Artists <span className="text-[#d4af37]">Say About Us</span>
          </h2>
        </div>

        <div className={`transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="glass-card rounded-3xl p-8 md:p-12 text-center relative">
            <div className="text-[#d4af37] text-5xl font-heading mb-6 leading-none">&ldquo;</div>
            <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-8 max-w-3xl mx-auto italic">
              {testimonials[active].quote}
            </p>
            <div className="flex items-center justify-center gap-4">
              <img
                alt={testimonials[active].name}
                className="w-14 h-14 rounded-full object-cover object-top border-2 border-[#d4af37]/40"
                src={testimonials[active].img}
              />
              <div className="text-left">
                <div className="text-white font-semibold font-heading">{testimonials[active].name}</div>
                <div className="text-[#d4af37] text-sm">{testimonials[active].role}</div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mt-8">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`transition-all duration-300 rounded-full cursor-pointer ${active === i ? 'w-8 h-2 bg-[#d4af37]' : 'w-2 h-2 bg-white/20 hover:bg-white/40'}`}
                aria-label={`Testimonial ${i + 1}`}
              />
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
            {testimonials.map((t, i) => (
              <button
                key={t.name}
                onClick={() => setActive(i)}
                className={`flex items-center gap-3 p-3 rounded-xl transition-all cursor-pointer text-left ${active === i ? 'glass-card border-[#d4af37]/30' : 'hover:bg-white/5'}`}
              >
                <img alt={t.name} className="w-10 h-10 rounded-full object-cover object-top flex-shrink-0" src={t.img} />
                <div>
                  <div className="text-white text-xs font-semibold">{t.name}</div>
                  <div className="text-white/40 text-xs">{t.role}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
